<template>
  <div class="home">
    
    <br/>
    <br/>
    <br/>
    
    <div class="main-content">
      <div class="relative" style="min-height: 550px;">
        <h1 class="text-left">
          Para evitar acidentes, <br/>devemos tomar cuidado
        </h1>
        <div class="carousel-text-container">
          <carousel class="messages__carousel"  :settings="carouselSettings">
            <slide v-for="(cuidado, idx) in cuidadosCarousel" :key="idx">
              <img :src="cuidado.frase" />
            </slide>
          </carousel>
        </div>


        <br/>
        <br/>
        <div class="text-left" style="width: 50%">
          <p class="main-subtitle w-1/2">A Rede SARAH já recebeu mais de 1 milhão de crianças e adolescentes para falar sobre o tema prevenção de acidentes. Agora, nossos conteúdos estão disponíveis on-line para serem acessados diretamente da escola, em casa, ou de onde você estiver!  </p>
        </div>
        <div class="carousel-imgs-container overflow-hidden">
          <div class="w-screen">
            
          </div>
          <carousel :settings="carouselSettings">
            <slide v-for="(cuidado, idx) in cuidadosCarousel" :key="idx">
              <img :src="cuidado.imagem"/>
            </slide>
          </carousel>
        </div>
      </div>
      <p class="main-subtitle--mobile mb-12">A Rede SARAH já recebeu mais de 1 milhão de crianças e adolescentes para falar sobre o tema prevenção de acidentes. Agora, nossos conteúdos estão disponíveis on-line para serem acessados diretamente da escola, em casa, ou de onde você estiver!  </p>
    </div>

    <br/>
    <br/>
    <br/>
    <br/>
    <br/>

    <content-section title="Veja quantos materiais preparamos pra você baixar gratuitamente e aprender a se proteger.">
      <div class="my-10 materiais-container">
        <topic-card :shadow="true" label="Vídeos" caption="Cérebro, Medula Espinhal, Trânsito, Mergulhos, Quedas..."
          class="cursor-pointer" @click="$router.push({ name: 'Conteudos' })">
          <template v-slot:bg-image><img src="../assets/geometric_1.png"/></template>
        </topic-card>
        <!-- <topic-card :shadow="true" label="Jogos" caption="Aprenda brincando... aqui, você pode baixar muitos materiais para saber mais sobre prevenção de acidentes">
          <template v-slot:bg-image><img src="../assets/geometric_2.png" style="width: 80px;"/></template>
        </topic-card> -->
        <topic-card :shadow="true" label="Quiz" caption="Assistiu aos nossos vídeos? Que tal responder a um quiz e baixar seu certificado?"
          class="cursor-pointer" @click="$router.push({ name: 'Quiz' })">
          <template v-slot:bg-image><img src="../assets/geometric_3.png"/></template>
        </topic-card>
        <topic-card :shadow="true" label="Material de Apoio" caption="Trânsito, Mergulhos e Quedas"
          class="cursor-pointer" @click="$router.push({ name: 'Conteudos', params: { scrollTo: 'materiais' } })">
          <template v-slot:bg-image><img src="../assets/geometric_4.png"/></template>
        </topic-card>
      </div>
    </content-section>

    <br/>
    <br/>
    <br/>

    <h2 class="inline-block w-5/6">Assista aos nossos vídeos e aprenda sobre o sistema nervoso central e como se prevenir de acidentes.</h2>
    <div class="mt-10 videos-container">
      <content-card
        v-for="(video, idx) in videosPepa"
        :key="video.caption"
        :caption="video.caption"
        :label="video.label"
        class="cursor-pointer"
        @click="$router.push({ name: 'Conteudos', params: { videoId: idx, scrollTo: 'videos' } })"
      >
        <template v-slot:image>
          <img :alt="video.label" :src="video.imgSrc" style="transform: scale(1.1);" />
        </template>
      </content-card>
    </div>

    <br/>
    <br/>
    <br/>

    <div style="border: 2px solid rgba(152, 152, 152, .3); border-radius: 50px;" class="py-5 px-15 mt-10">
      <h2 class="inline-block w-5/6">Galeria dos Participantes</h2>
      <carousel class="mt-10 hidden md:block" :settings="carouselGaleriaSettings">
        <slide v-for="(arte, idx) in galeriaCarousel" :key="idx">
          <content-card :caption="arte.autor" :label="arte.titulo">
            <template v-slot:image>
              <img :src="arte.imagem" style="width: 400px; transform: scale(1.1)" @click="selcionarArte(arte)" />
            </template>
          </content-card>
        </slide>
      </carousel>
      <button class="rounded-lg bg-red mt-6 px-6 py-4 text-white" style="background-color: #F69E36; border-radius: 50px"
        @click="$router.push({ name: 'Galeria' })">Acesse nossa galeria!</button>
    </div>
  </div>
</template>

<script>
import TopicCard from '../components/common/TopicCard.vue'
import ContentCard from '../components/common/ContentCard.vue'
import ContentSection from '../components/common/ContentSection.vue'
import VideosPepa from '../data/VideosPepa'

import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide } from 'vue3-carousel';

import SvgFraseBrincadeiras from '../assets/cuidados/frase_brincadeiras.svg'
import SvgFraseMergulho from '../assets/cuidados/frase_mergulho.svg'
import SvgFrasePassageiros from '../assets/cuidados/frase_passageiros.svg'
import SvgFraseSinalFaixa from '../assets/cuidados/frase_sinal_faixa.svg'

export default {
  components: { ContentSection, ContentCard, TopicCard, Carousel, Slide },
  data() {
    return {
      videosPepa: VideosPepa,
      carouselSettings: {
        itemsToShow: 1,
        autoplay: 1000 * 5,
        wrapAround: true,
        transition: 500,
        mouseDrag: false,
        touchDrag: false,
        snapAlign: 'end'
      },
      carouselGaleriaSettings: {
        itemsToShow: 3,
        autoplay: 1000 * 3,
        wrapAround: true,
        transition: 500,
        mouseDrag: false,
        touchDrag: false,
      },
      cuidadosCarousel: [
        { imagem: require('../assets/cuidados/sinal_faixa.png'), frase: SvgFraseSinalFaixa },
        { imagem: require('../assets/cuidados/passageiros.png'), frase: SvgFrasePassageiros },
        { imagem: require('../assets/cuidados/brincadeiras.png'), frase: SvgFraseBrincadeiras },
        { imagem: require('../assets/cuidados/mergulho.png'), frase: SvgFraseMergulho },
      ],
      galeriaCarousel: [
        // { autor: 'João Lucas, 10 anos', titulo: 'Olhe bem antes de mergulhar', imagem: require('../assets/galeria/arte_1.png') },
        { autor: 'João Lucas, 10 anos', titulo: 'Cuidado na avenida', imagem: require('../assets/galeria/texto_2.png') },
        { autor: 'João Lucas, 10 anos', titulo: 'Acidente na primeira infância', imagem: require('../assets/galeria/texto_3.png') },
        { autor: 'Anita, 10 anos', titulo: 'Prevenção de acidentes', imagem: require('../assets/galeria/texto_4.png') },
        { autor: 'João Lucas, 10 anos', titulo: 'Cuidado na avenida', imagem: require('../assets/galeria/arte_2.png') },
      ],
    }
  }
}  
</script>

<style>
.main-subtitle {
  font-family: Roboto;
  font-size: 1.1rem;
  font-style: normal;
  letter-spacing: 0em;
  text-align: left;
  color: #8B8B8B;
  display: none;
}

.main-subtitle--mobile {
  font-family: Roboto;
  font-size: 1.1rem;
  font-style: normal;
  letter-spacing: 0em;
  color: #8B8B8B;
  text-align: center;
}

.messages__carousel .carousel__track .carousel__slide--active {
  justify-content: flex-start !important
}

.materiais-container {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 5rem;
  margin-left: 10px;
  margin-right: 10px;
}

.videos-container {
  display: flex;
  flex-direction: column;
}

.carousel-imgs-container {
  max-width: 700px;
}

.carousel-text-container {
  max-width: 75%;
}

@media (min-width: 768px) {
  .materiais-container {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 5rem;
  }

  .videos-container {
    display: grid;
    grid-template-columns: auto auto auto;
    justify-items: center;
    gap: 2.5 rem;
  }
}

@media (max-width: 767px) {
  .materiais-container {
    gap: 1rem;
  }

  .videos-container {
    gap: 2.5 rem;
  }
}

@media (min-width: 1200px) {
  .main-subtitle  {
    display: unset;
  }

  .carousel-text-container {
    max-width: 50%;
  }

  .main-subtitle--mobile  {
    display: none;
  }

  .carousel-imgs-container {
    position: absolute;
    right: 0;
    top: -52px;
    width: 700px;
  }

  .title-content {
    padding-left: 5rem;
    padding-right: 5rem;
  }
}
</style>
